module.exports = __webpack_public_path__ + "img/logo-blanco.d5fae773.png";